import { MockAuth } from "@/lib/mockAuth";
import { initializeApp } from "firebase/app";
import type { Auth } from "firebase/auth";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env["VITE_REACT_APP_FIREBASE_API_KEY"],
  authDomain: import.meta.env["VITE_REACT_APP_FIREBASE_AUTH_DOMAIN"],
  projectId: import.meta.env["VITE_REACT_APP_FIREBASE_PROJECT_ID"],
  storageBucket: import.meta.env["VITE_REACT_APP_FIREBASE_STORAGE_BUCKET"],
  messagingSenderId: import.meta.env[
    "VITE_REACT_APP_FIREBASE_MESSAGE_SENDER_ID"
  ],
  appId: import.meta.env["VITE_REACT_APP_FIREBASE_APP_ID"],
  measurementId: import.meta.env["VITE_REACT_APP_MEASUREMENT_ID"],
};

const useMockAuth =
  import.meta.env["VITE_REACT_APP_FIREBASE_USE_MOCK_AUTH"] === "true";

let auth: Auth | MockAuth;

if (useMockAuth) {
  auth = new MockAuth();
} else {
  const app = initializeApp(firebaseConfig);
  auth = getAuth(app);
}

export { auth };
